import { render } from "./indexItem.vue?vue&type=template&id=0bb52db4"
import script from "./indexItem.vue?vue&type=script&setup=true&lang=js"
export * from "./indexItem.vue?vue&type=script&setup=true&lang=js"

import "./indexItem.vue?vue&type=style&index=0&id=0bb52db4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserManagement/RoleManagement/indexItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb52db4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb52db4', __exports__)) {
    api.reload('0bb52db4', __exports__)
  }
  
  module.hot.accept("./indexItem.vue?vue&type=template&id=0bb52db4", () => {
    api.rerender('0bb52db4', render)
  })

}


export default __exports__